import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { MATCH_TENNIS, PAGE_LIMIT } from "helpers/viewContent";
import { DATE_FORMAT_TIME } from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { getList_ } from "store/services/commonService";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Button } from "react-bootstrap";

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount, loader }) => {
  //pagination
  const [activePage, setActivePage] = useState(1);
  const [listing, setListing] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const history = useHistory();

  const fetchData = async () => {
    try {
      let query = {
        url: "match/list",
        page: activePage,
        limit: PAGE_LIMIT,
        common: false,
        match_type: tabIndex,
        search_string: searchValue,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getList_(query));
      dispatch(actions.persist_store({ loader: false }));
      setListing(res?.body?.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activePage, tabIndex]);

  //pagination
  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };
  return (
    <>
      <Helmet title={MATCH_TENNIS.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-view-stream menu-icon"></i>
          </span>{" "}
          {MATCH_TENNIS.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.match}>{MATCH_TENNIS.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Upcoming Matches</Tab>
          <Tab>Past Matches</Tab>
          <Tab>No Player Found Matches</Tab>
        </TabList>
        <div className="row">
          {listing?.length > 0 &&
            listing.map((list, i) => {
              return (
                <div className="col-md-4 grid-margin stretch-card" key={i}>
                  <div className="card">
                    <div className="card-body p-3">
                      <div className="row">
                        <div className="col-sm-9">
                          <h4 className="card-title">{list?.match_title}</h4>
                        </div>
                        <div className="col-sm-2 px-0">
                          <Link to={`${Path.matchview}/${list?.id}`}>
                            <label
                              className="btn btn-sm btn btn-gradient-info  "
                              style={{ cursor: "pointer" }}
                              title="View"
                            >
                              <i className="mdi mdi-eye"></i>
                            </label>
                          </Link>
                        </div>
                      </div>

                      <div className="py-2 text-end d-flex justify-content-end">
                        <div
                          onClick={() =>
                            history.push(`${Path.matchlogs}/${list?.id}`)
                          }
                          className="rounded w-auto btn-gradient-info p-1 px-2 cursor-pointer "
                          to={`${Path.matchview}/${list?.id}`}
                        >
                          {" "}
                          View Logs
                        </div>
                      </div>

                      <p>
                        {" "}
                        Match Date :{" "}
                        {list?.match_date
                          ? DATE_FORMAT_TIME(list?.formatted_match_datetime)
                          : "N/A"}
                      </p>
                      <p> Location : {list?.location}</p>
                      {list?.match_request && (
                        <p>
                          {" "}
                          Match Fee :{" "}
                          {list?.match_request
                            ? `$${list?.match_request?.match_fee}`
                            : ""}
                        </p>
                      )}
                      <p>
                        {" "}
                        Status : &nbsp;&nbsp;
                        <label
                          style={{ cursor: "pointer" }}
                          className={`badge badge-gradient-${
                            list?.accepted_requests === 0
                              ? "danger"
                              : list?.status === "1"
                                ? "info"
                                : list?.status === "2"
                                  ? "success"
                                  : "danger"
                          }`}
                        >
                          {list?.accepted_requests === 0
                            ? "No Player Found"
                            : list?.status === "1"
                              ? "Ongoing"
                              : list?.status === "2"
                                ? "Completed"
                                : "Pending"}
                        </label>
                      </p>
                      <p>
                        {" "}
                        Created At :{" "}
                        {list?.created_at
                          ? DATE_FORMAT_TIME(list?.created_at)
                          : "N/A"}
                      </p>
                      <hr />
                      <h5>User Detail : </h5>
                      <div className="match_tennis_list">
                        {/* <p>Host Detail :</p> */}
                        <p>
                          Name :{" "}
                          {list?.user_details?.name
                            ? `${list?.user_details?.name}`
                            : "N/A"}
                        </p>
                        <p>
                          Email :{" "}
                          {list?.user_details?.email
                            ? `${list?.user_details?.email}`
                            : "N/A"}
                        </p>
                      </div>
                      <hr />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </Tabs>
      {listing.length > 0 && (
        <div className="pagination-box-review">
          <ReactPagination
            activePage={activePage}
            itemsCountPerPage={itemsCountPerPage}
            totalItemsCount={totalItemsCount}
            handlePageChange={handlePageChange}
          />
        </div>
      )}
      {listing.length == 0 && (
        <div className="row">
          <div className="col-md-6 pt-5">
            <span>No data found...</span>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Common.itemsCountPerPage,
    totalItemsCount: state.Common.totalItemsCount,
    loader: state.Common.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
